import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { _ } from '/@/locale';
import styles from './styles.module.css';

const sizes = /** @type {const} */ ['sm', 'md', 'lg'];
const colors = /** @type {const} */ ['black', 'gray-opacity'];
const appearances = /** @type {const} */ ['row', 'column'];

/**
 * @extends {React.Component<{
 * size: typeof sizes[number]
 * color: typeof colors[number]
 * appearance: typeof appearances[number]
 * reverse: boolean
 * text: React.ReactNode
 * children: React.ReactNode
 * className: string
 * required: boolean
 * }>}
 */
@autobind
export default class Label extends Component {
    static propTypes = {
        size: PropTypes.oneOf(sizes),
        color: PropTypes.oneOf(colors),
        appearance: PropTypes.oneOf(appearances),
        reverse: PropTypes.bool,
        text: PropTypes.any,
        children: PropTypes.element,
        className: PropTypes.string,
        required: PropTypes.bool,
    };

    static defaultProps = {
        size: 'md',
        color: 'black',
        appearance: 'column',
        required: false,
    };

    render() {
        const className = classNames(
            styles.root,
            styles[`size-${this.props.size}`],
            styles[`color-${this.props.color}`],
            styles[`appearance-${this.props.appearance}`],
            this.props.reverse && styles.reverse,
            this.props.className
        );
        return (
            <div className={className}>
                <div className={styles.text}>
                    {this.props.text}
                    {this.props.required && <span className={styles.required}>* {_('Requerido')}</span>}
                </div>
                {this.props.children}
            </div>
        );
    }
}
